import styled from "styled-components";

export const ShopDetailWrapper = styled.div`
  .link:hover {
    text-decoration: underline;
  }
`;
